import axios from "axios";
import { LOGOUT } from "../utils/constants";

// Automatski izbor: `npm start` (development) -> localhost,
// `npm run build` (production) -> live API. Tako se localhost ne može
// slučajno deploy-ovati.
export const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.mitovka.com"
    : "http://localhost:5002";

const API_BASE_URL = `${BASE_URL}/api`;
const AUTH_BASE_URL = `${BASE_URL}/api/auth`;

let store;

export const injectStore = (_store) => {
  store = _store;
};

const axiosAuthClient = axios.create({
  baseURL: AUTH_BASE_URL,
  withCredentials: true,
});

const axiosApiPublicClient = axios.create({
  baseURL: `${BASE_URL}/`,
});

const axiosApiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Dedicated client for file uploads without interceptors
const axiosFileUploadClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

axiosAuthClient.interceptors.request.use(
  (config) => {
    config.headers = {
      "Content-Type": "application/json",
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosApiPublicClient.interceptors.request.use(
  async (config) => {
    config.headers["X-MY-CSRF-PROTECTION"] = 5;
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

axiosApiClient.interceptors.request.use(
  (config) => {
    // Only set JSON Content-Type if not already set (allows FormData to set its own)
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Shared refresh promise so parallel 401s trigger a single POST /refresh
let refreshPromise = null;

const refreshSession = () => {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(`${API_BASE_URL}/user/refresh`, {}, { withCredentials: true })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
};

axiosApiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Try to refresh the token using cookies (shared across parallel 401s)
        await refreshSession();

        // Retry the original request with refreshed cookie
        return axios(originalRequest);
      } catch (refreshError) {
        // If refresh fails, log the user out so ProtectedRoute redirects to /pristup.
        // VAŽNO: samo ako je korisnik zaista bio ulogovan — kod gosta bi LOGOUT
        // resetovao ceo store i obrisao već učitane javne podatke (npr. kurseve
        // na početnoj), jer slice-ovi na LOGOUT vraćaju initialState.
        if (store?.getState()?.authInfo?.loggedIn === true) {
          store.dispatch({ type: LOGOUT });
        }
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default axiosApiClient;
export {
  axiosAuthClient,
  axiosApiClient,
  axiosApiPublicClient,
  axiosFileUploadClient,
};
